import axios from "axios";

export const signup = (payload) => axios.post("/api/v1/signup", payload);

export const login = (payload) => axios.post("/api/v1/users/login", payload);

// endpoint to authorize the user with Okta's API
// We are using this instead of redirecting to Okta sign in page.
export const oktaLogin = (payload) =>
    axios.post(`${process.env["OKTA_URL"]}/api/v1/authn`, payload);

export const setUserSession = (payload) =>
    axios.post("/api/v1/users/oktalogin", { user: payload });

export const logout = () => axios.get("/api/v1/users/logout");

export const reset = (payload) => axios.post("/api/v1/users/reset", payload);
